/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Hero_SecondaryInputs */

const en_landing_hero_secondary = /** @type {(inputs: Landing_Hero_SecondaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dashboard`)
};

const zh_landing_hero_secondary = /** @type {(inputs: Landing_Hero_SecondaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`控制台`)
};

/**
* | output |
* | --- |
* | "Dashboard" |
*
* @param {Landing_Hero_SecondaryInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_hero_secondary = /** @type {((inputs?: Landing_Hero_SecondaryInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Hero_SecondaryInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_hero_secondary(inputs)
	return zh_landing_hero_secondary(inputs)
});
export { landing_hero_secondary as "landing.hero.secondary" }